export default class BoardService {
    constructor(resource) {
        this.resource = resource;
    }

    get(path, params) {
        return this.resource.get(`/api/board/${path}`, params)
    }
}